import { IllustrationName } from 'src/lib/components/atoms/illustration/illustration';

import { ContentCard, ContentCardState } from '../../../../../components/molecules/content-card/content-card';

type TocCardState = 'to-do' | 'in-progress' | 'done';

type TocCardProps = {
  readonly index: number;
  readonly title: string;
  readonly description?: string;
  readonly state: TocCardState;
  readonly onClick?: () => void;
};

const ImageBank: IllustrationName[][] = [
  ['Woman1', 'Woman1Locked'],
  ['Man1', 'Man1Locked'],
  ['Man2', 'Man2Locked'],
  ['Woman2', 'Woman2Locked'],
  ['Man3', 'Man3Locked'],
  ['Woman3', 'Woman3Locked'],
];

const mapState: Record<TocCardState, ContentCardState> = {
  'to-do': 'locked',
  'in-progress': 'highlighted',
  done: 'active',
};

const TocCard = ({ state, title, index, description, onClick }: TocCardProps) => {
  const imageIndex = index % ImageBank.length;
  const image = ImageBank[imageIndex][state === 'to-do' ? 1 : 0];

  return (
    <ContentCard
      description={state === 'in-progress' ? description : undefined}
      image={image}
      onClick={onClick}
      state={mapState[state]}
      title={title}
    ></ContentCard>
  );
};

export { TocCard };
export type { TocCardState };
